"use client"

import { useAutoAnimate } from "@formkit/auto-animate/react"
import { Fragment } from "react"
import { CartProduct } from "src/components/cart/CartProduct"
import { useCartState } from "src/components/checkout/hooks/useCart"
import { Divider } from "src/components/generic/Divider"

export const CartSidebarItems = () => {
  const { data: cart } = useCartState()
  const [animationParent] = useAutoAnimate()

  return (
    <div ref={animationParent} className="@container flex flex-col justify-start gap-6 py-6">
      {cart?.items?.map((item) => {
        return (
          <Fragment key={item.id}>
            <Divider color="green" />
            <div className="xs:px-6 px-4">
              <CartProduct item={item} />
            </div>
          </Fragment>
        )
      })}
    </div>
  )
}
